/**
 * Fetches a short-lived single-use WebSocket ticket from the backend.
 * The ticket is valid for 30 s and is consumed on the first WebSocket handshake,
 * so a fresh one must be fetched for every connection attempt.
 */
export async function fetchWsTicket(jwt) {
  const res = await fetch(`${process.env.REACT_APP_API_BASE_URL}/api/v1/auth/ws-ticket`, {
    method: 'POST',
    headers: { Authorization: `Bearer ${jwt}` },
  });
  if (!res.ok) throw new Error(`Failed to obtain WebSocket ticket: ${res.status}`);
  const { ticket } = await res.json();
  return ticket;
}
